import { render } from "./search-form.global.vue?vue&type=template&id=6bf1ec35&scoped=true"
import script from "./search-form.global.vue?vue&type=script&lang=js"
export * from "./search-form.global.vue?vue&type=script&lang=js"

import "./search-form.global.vue?vue&type=style&index=0&id=6bf1ec35&lang=scss&scoped=true"

import exportComponent from "/builds/grxl/cinematech/jmpt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bf1ec35"]])

export default __exports__